'use client';

import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import PrivateProfileBanner from '@/app/[locale]/(worlds)/profile/components/PrivateProfileBanner';
import PrivateProfileContent from '@/app/[locale]/(worlds)/profile/components/PrivateProfileContent';
import PrivateProfileIntro from '@/app/[locale]/(worlds)/profile/components/PrivateProfileIntro';
import ProfilePageWrapper from '@/app/[locale]/(worlds)/profile/components/ProfilePageWrapper';
import { OwnerProfileProvider, useOwnerProfileContext } from '@/context/OwnerProfileContext';
import type { Room } from '@/services/cms';
function OwnerProfileGateInner(t0) {
  const $ = _c(1);
  const {
    children
  } = t0;
  const {
    isOwner,
    isPublicView
  } = useOwnerProfileContext();
  const showPrivateProfile = isOwner && !isPublicView;
  if (showPrivateProfile) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProfilePageWrapper><PrivateProfileBanner /><PrivateProfileIntro /><PrivateProfileContent /></ProfilePageWrapper>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  return children;
}
type OwnerProfileGateProps = {
  targetUserId?: string;
  coOwnedRoomsPromise: Promise<Room[]>;
  featuredRoomsPromise: Promise<Room[]>;
};
export default function OwnerProfileGate(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.children) {
    t0 = <OwnerProfileGateInner>{props.children}</OwnerProfileGateInner>;
    $[0] = props.children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.coOwnedRoomsPromise || $[3] !== props.featuredRoomsPromise || $[4] !== props.targetUserId || $[5] !== t0) {
    t1 = <OwnerProfileProvider targetUserId={props.targetUserId} coOwnedRoomsPromise={props.coOwnedRoomsPromise} featuredRoomsPromise={props.featuredRoomsPromise}>{t0}</OwnerProfileProvider>;
    $[2] = props.coOwnedRoomsPromise;
    $[3] = props.featuredRoomsPromise;
    $[4] = props.targetUserId;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}